import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChatIcon, StorefrontIcon } from '@yonderland/andes-icons';
import { Breakpoint, ConditionalWrapper, Icon, Link } from '@yonderland/andes-react';
const ICONS_MAPPING = {
    stores: StorefrontIcon,
    help: ChatIcon,
    support: ChatIcon,
};
const QuickLinksItem = ({ linkKey, linkName, linkPath, hideOnMobile, target }) => {
    return (_jsx(ConditionalWrapper, { condition: !!hideOnMobile, wrapper: children => _jsx(Breakpoint, { from: "md", children: children }), children: _jsxs(Link, { testId: linkKey, theme: "neutral", variant: "tertiary", size: "sm", href: linkPath, target: target, children: [ICONS_MAPPING[linkKey] && _jsx(Icon, { size: "sm", source: ICONS_MAPPING[linkKey] }), linkName] }) }));
};
export default QuickLinksItem;
